import { Box, Hide, Link } from "@chakra-ui/react";
import { BsGithub } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";

import React from "react";

const Side = () => {
  return (
    <div>
      <Hide below="md">
        <Link href="https://github.com/mira713">
          <Box
            border={"4px solid orangered"}
            position="fixed"
            mt="21rem"
            ml={["2rem", "3rem", "4rem", "5rem"]}
          >
            <BsGithub size={[40]} color="orangered" />
          </Box>
        </Link>
        <Link href="https://www.linkedin.com/in/mitali-sinha-183134203/">
          <Box
            border={"4px solid orangered"}
            position="fixed"
            mt={["27rem"]}
            ml={["2rem", "3rem", "4rem", "5rem"]}
          >
            <FaLinkedinIn size={[40]} color="orangered" />
          </Box>
        </Link>
      </Hide>
    </div>
  );
};

export default Side;
